import React, { createContext, useState } from 'react';

import { api } from '../middlewares';
import { formatDateYYYYMMDD } from '../Utils/formatDate';

const ContextoFinanceiro = createContext();

function Financeiro({ children }) {
  const [parcelaBloqueadaClicada, setParcelaBloqueadaClicada] = useState('');

  const [codigoCopiado, setCodigoCopiado] = useState(false);

  const [erroGetCopiarCodigo, setErroGetCopiarCodigo] = useState(false);

  const [emailEnviado, setEmailEnviado] = useState(false);

  const [erroEnviarEmail, setErroEnviarEmail] = useState(false);

  const [error, setError] = useState(false);

  const [loadingEnviaBoletoPorEmail, setLoadingEnviaBoletoPorEmail] =
    useState(false);

  const [boletoSelecionado, setBoletoSelecionado] = useState('');

  const [loadingCopiarCodigo, setLoadingCopiarCodigo] = useState(false);

  const [boletoCodigoCopiado, setBoletoCodigoCopiado] = useState('');

  const [parcelasPix, setParcelasPix] = useState([]);

  const [showModalGerarPix, setShowModalGerarPix] = useState(false);

  const [holidays, setHolidays] = useState([]);

  const [dadosDocSign, setDadosDocSign] = useState({});

  async function getContratosCliente() {
    return await api.get('/Financeiro/GetContratoCliente');
  }

  function getBoletos() {
    return api.get('/Notificacao/GetBoletosPendentes');
  }

  function getDadosBoleto(Cod_banco, Seu_numero) {
    return api.get('/Financeiro/ConsultarDadosDoBoleto', {
      params: {
        Cod_banco,
        Seu_numero,
      },
    });
  }

  function getVisualizarBoleto(Cod_banco, Seu_numero) {
    return api.get('/Financeiro/VisualizarPdfBoleto', {
      params: {
        Cod_banco,
        Seu_numero,
      },
    });
  }

  async function validaAssinaturaDocuSign(idVenda, idVendaCarteira) {
    const { data } = await api.get('Renegociacao/ValidarAssinaturaDocuSign', {
      params: {
        idVenda,
        idVendaCarteira,
      },
    });

    if (data) {
      saveDataDocSign(data);
      return data;
    }
  }

  function saveDataDocSign({
    habilitarFinanceiro,
    habilitarReenvio,
    envelopeId,
    email,
    minutosReenvio,
  }) {
    const dadosDocSign = {
      habilitarFinanceiro,
      bannerAditivo: {
        showBannerAditivo: !habilitarFinanceiro,
        showBotaoReenviarAditivo: !habilitarFinanceiro && !habilitarReenvio,
      },
      envelopeId,
      email,
      minutosReenvio,
    };

    setDadosDocSign(dadosDocSign);
  }

  function getParcelasAPagar(idsVenda) {
    return api.get('Financeiro/ParcelasAReceber', {
      params: {
        IdVenda: idsVenda?.IdVenda,
        IdVendaCarteira: idsVenda?.IdVendaCarteira,
      },
    });
  }

  function getParcelasPagas(idsVenda) {
    return api.get('Financeiro/ParcelasRecebidas', {
      params: {
        IdVenda: idsVenda.IdVenda,
        IdVendaCarteira: idsVenda.IdVendaCarteira,
      },
    });
  }

  function getExtrato(idsVenda) {
    return api.get('Financeiro/Extrato', {
      params: {
        IdVenda: idsVenda.IdVenda,
        IdVendaCarteira: idsVenda.IdVendaCarteira,
      },
    });
  }

  function visualizarPdfExtrato(idsVenda) {
    return api.get('Financeiro/VisualizarPdfExtrato', {
      params: {
        IdVenda: idsVenda.IdVenda,
        IdVendaCarteira: idsVenda.IdVendaCarteira,
      },
    });
  }

  function visualizarPdfDemonstrativoIRRF(idsVenda) {
    return api.get('Financeiro/VisualizarPdfDemonstrativoIRRF', {
      params: {
        IdVenda: idsVenda.IdVenda,
        IdVendaCarteira: idsVenda.IdVendaCarteira,
      },
    });
  }

  // busca no uau, quando a pessoa alterar a data de vencimento do boleto
  async function getParcelasAReceberNoUAU(dadosContaUsuario) {
    try {
      let resultGetParcelasAReceberNoUAU = await api.get(
        'Financeiro/BuscarParcelasAReceber',
        {
          params: {
            ...dadosContaUsuario,
          },
        }
      );

      return resultGetParcelasAReceberNoUAU.data;
    } catch (error) {
      return error.request;
    }
  }

  async function getFinanceiroConsultarDescontoAntecipacaoParcela(
    dadosContaUsuario
  ) {
    let resultGet = {};
    resultGet = await api.get(
      'Financeiro/ConsultarDescontoAntecipacaoParcela',
      {
        params: {
          Empresa: dadosContaUsuario.Empresa,
          Obra: dadosContaUsuario.Obra,
          num_venda: dadosContaUsuario.num_venda,
          Num_parc: dadosContaUsuario.Num_parc,
          Numparc_ger: dadosContaUsuario.Numparc_ger,
          Tipo_parc: dadosContaUsuario.Tipo_parc,
          Data_calculo: dadosContaUsuario.Data_calculo,
          Valor_parcela: dadosContaUsuario.Valor_parcela,
          Data_vencimento: dadosContaUsuario.Data_vencimento,
          Data_prorrogacao: dadosContaUsuario.Data_prorrogacao,
        },
      }
    );
    return resultGet.data;
  }

  async function getDemonstrativoIRRF() {
    try {
      let resultGetDemonstrativoIRRF = await api.get(
        'Financeiro/DemonstrativoIRRF'
      );
      return resultGetDemonstrativoIRRF.data;
    } catch (error) {
      return error.request;
    }
  }

  async function postFinanceiroGerarBoleto(parcelas) {
    return await api.post('Financeiro/GerarBoleto', {
      ...parcelas,
    });
  }

  async function postEnvioEmailPdfBoleto(Cod_banco, Seu_numero) {
    return await api.post('Financeiro/EnvioEmailPdfBoleto', {
      Cod_banco,
      Seu_numero,
    });
  }

  async function postEnviarExtratoEmail(base64) {
    return await api.post('/Financeiro/EnvioEmailExtrato', {
      Base64: base64,
    });
  }

  async function postEnviarIrrfEmail(base64) {
    return await api.post('/Financeiro/EnvioEmailIrrf', {
      Base64: base64,
    });
  }

  async function postPDFEnviaBoleto(Cod_banco, Seu_numero) {
    setLoadingEnviaBoletoPorEmail(true);
    setBoletoCodigoCopiado(Seu_numero);
    try {
      await postEnvioEmailPdfBoleto(Cod_banco, Seu_numero);
      setEmailEnviado(true);
    } catch (error) {
      setErroEnviarEmail(true);
      return [];
    } finally {
      setLoadingEnviaBoletoPorEmail(false);
      setBoletoSelecionado('');
    }
  }

  function verificaSeParcelaAtrasada(dataVencimento) {
    if (new Date(dataVencimento).getTime() < new Date().getTime()) return true;
  }

  function defineEstiloSeParcelaAtrasada(dataVencimento) {
    if (verificaSeParcelaAtrasada(dataVencimento))
      return {
        color: '#BA122B',
        fontWeight: '900',
        fontSize: '15px',
        width: '100%',
      };
    else
      return {
        color: 'rgba(77,77,77)',
        fontWeight: '900',
        fontSize: '15px',
        width: '100%',
      };
  }

  async function copiaCodigoBoleto(bancoBoleto, seuNumero) {
    setBoletoSelecionado(seuNumero);
    setLoadingCopiarCodigo(true);
    setBoletoCodigoCopiado(seuNumero);
    try {
      const resultGetCodigoBoleto = await getDadosBoleto(
        bancoBoleto,
        seuNumero
      );
      navigator.clipboard.writeText(
        resultGetCodigoBoleto.data.LinhaDigitavel_Bol
      );
      setCodigoCopiado(true);
    } catch (error) {
      setErroGetCopiarCodigo(true);
    } finally {
      setLoadingCopiarCodigo(false);
      setBoletoSelecionado('');
    }
  }

  if (codigoCopiado || erroGetCopiarCodigo || emailEnviado || erroEnviarEmail)
    setTimeout(() => {
      setCodigoCopiado(false);
      setErroGetCopiarCodigo(false);
      setEmailEnviado(false);
      setErroEnviarEmail(false);
    }, 5000);

  if (error)
    setTimeout(() => {
      setError(false);
    }, 5000);

  async function gerarPix(payload) {
    const { data } = await api.post('/Financeiro/GerarPix', {
      ...payload,
    });

    return data;
  }

  async function getHolidays() {
    try {
      if (holidays?.length === 0) {
        const { data } = await api.get(
          `https://brasilapi.com.br/api/feriados/v1/${new Date().getFullYear()}`
        );

        if (data) {
          setHolidays(data);
          return data;
        }
      }
      return holidays;
    } catch (error) {
      return null;
    }
  }

  function checkIsHoliday(date) {
    const formatedDate = formatDateYYYYMMDD(date);
    const isHoliday = holidays.some(
      (holiday) => holiday?.date === formatedDate
    );
    return isHoliday;
  }

  return (
    <ContextoFinanceiro.Provider
      value={{
        setDadosDocSign,
        dadosDocSign,
        validaAssinaturaDocuSign,
        getContratosCliente,
        getParcelasAPagar,
        getParcelasPagas,
        getParcelasAReceberNoUAU,
        getFinanceiroConsultarDescontoAntecipacaoParcela,
        getExtrato,
        getDemonstrativoIRRF,
        postFinanceiroGerarBoleto,
        getBoletos,
        getVisualizarBoleto,
        postEnvioEmailPdfBoleto,
        visualizarPdfExtrato,
        visualizarPdfDemonstrativoIRRF,
        postEnviarExtratoEmail,
        postEnviarIrrfEmail,
        getDadosBoleto,
        parcelaBloqueadaClicada,
        setParcelaBloqueadaClicada,
        codigoCopiado,
        loadingCopiarCodigo,
        erroGetCopiarCodigo,
        copiaCodigoBoleto,
        error,
        setError,
        defineEstiloSeParcelaAtrasada,
        verificaSeParcelaAtrasada,
        postPDFEnviaBoleto,
        loadingEnviaBoletoPorEmail,
        setLoadingEnviaBoletoPorEmail,
        boletoSelecionado,
        setBoletoSelecionado,
        boletoCodigoCopiado,
        emailEnviado,
        erroEnviarEmail,
        showModalGerarPix,
        setShowModalGerarPix,
        parcelasPix,
        setParcelasPix,
        gerarPix,
        getHolidays,
        holidays,
        checkIsHoliday,
      }}
    >
      {children}
    </ContextoFinanceiro.Provider>
  );
}
export { Financeiro, ContextoFinanceiro };
